import React from "react";
import { Typography } from "antd";

const { Text } = Typography;

const InfoItem = ({ label, value, icon }) => (
  <div style={{ marginBottom: 12 }}>
    <Text type="secondary" style={{ fontSize: 16, display: "block" }}>
      {icon && <span style={{ marginRight: 6 }}>{icon}</span>}
      {label}
    </Text>
    <Text strong style={{ fontSize: 18 }}>
      {value || "-"}
    </Text>
  </div>
);

export default InfoItem;
